import React from 'react';

import { IconProps } from './types';

export const CycleIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', ...props }, forwardedRef) => {
    return (
      <svg
        fill="none"
        height="32"
        viewBox="0 0 32 32"
        width="32"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          d="M17.0001 2.75C16.5834 4.59896 15.7084 6.29688 14.2397 7.35938C13.8594 7.63542 13.948 8.20313 14.3959 8.32813C16.0157 8.76563 17.4011 10.0156 18.4584 11.7083"
          stroke="#8E8E93"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="2"
        />
        <path
          d="M14.0054 7.85936C19.5991 6.34894 23.7918 7.48436 26.0002 8.99998C27.2241 11.4844 27.5002 19 26.0002 23C24.5002 24 23.0002 24 23.0002 24"
          stroke="#8E8E93"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="2"
        />
        <path
          d="M15.0003 29.2498C15.417 27.4009 16.292 25.703 17.7607 24.6405C18.141 24.3644 18.0524 23.7967 17.6045 23.6717C15.9847 23.2342 14.5993 21.9842 13.542 20.2915"
          stroke="#8E8E93"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="2"
        />
        <path
          d="M17.995 24.1406C12.4012 25.651 8.2085 24.5156 6.00017 23C4.77621 20.5156 4.50017 13 6.00017 9C7.32308 8 9.00017 8 9.00017 8"
          stroke="#8E8E93"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="2"
        />
      </svg>
    );
  },
);
